import { Button, Heading, Stack } from "@origin-digital/ods-core";
import React from "react";

const FDV_PATH = "family-and-domestic-violence";

interface IFdvExit {
  path?: string;
}

export const FdvExit = ({ path }: IFdvExit) => {
  if (!path || !path.includes(FDV_PATH)) return null;

  const replaceHistory = () => {
    history.replaceState(null, "", window.location.origin);
  };

  return (
    <Stack>
      <Heading data-id="fdv-heading" variant="h4" component="h2">
        If you’re in immediate danger, call 000 for emergency services.
      </Heading>
      <Button href="https://www.google.com" onClick={replaceHistory}>
        Quick exit
      </Button>
    </Stack>
  );
};
